import { PropsWithChildren } from "react"
import { Navigate } from "react-router-dom"

import { useContentStudioP1aStatus } from "@/hooks/useContentStudioP1a"

import { FlagsPending } from "./ComingSoonRoute.tsx"
import routes from "./routes.ts"

/**
 * P2+ «Add creative» lives outside DashboardLayout, so it cannot rely on ComingSoonRoute: it waits for
 * `content_studio_p1a` and `communication_hub` itself, and sends anyone without both to the Library,
 * which shows Coming Soon or the current page as it does today.
 */
const AddCreativeRoute = ({ children }: PropsWithChildren) => {
  const { ready, failed, retry, enabled } = useContentStudioP1aStatus()

  if (!ready) {
    return <FlagsPending failed={failed} onRetry={() => void retry()} />
  }

  if (!enabled) {
    return <Navigate to={routes["dashboard/content-studio"]} replace />
  }

  return <>{children}</>
}

export default AddCreativeRoute
